module.exports = __webpack_public_path__ + "img/invoice.fd54da1e.svg";